export default "__VITE_ASSET__CUZfz8nY__"